import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import { Spinner } from '../../App/Components'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { AddAbsenceRequestNew } from '../../HR/AbsenceRequestNew/AddAbsenceRequestNew.page'
import { EditAbsenceRequestNewPage } from '../../HR/AbsenceRequestNew/EditAbsenceRequestNew.page'
import {
  getAbsenceRequests,
  getAbsenceStatistics,
} from '../../HR/AbsenceRequests/Store/Actions'
import { currentUserSelector } from '../../User/Store/reducer'
import { Profile, ProfileSettings } from '../Pages'
import { UpdateAbsenceRequest } from '../Pages/AbsenceRequest'

export const ProfileBootstrap = () => {
  const dispatch = useAppDispatch()
  const { absenceRequests, personStatistics } = useAppSelector(state => {
    return {
      absenceRequests: state.hr.absenceRequests.list,
      personStatistics: state.hr.absenceRequests.statistics,
    }
  })

  const user = useAppSelector(currentUserSelector)

  useEffect(() => {
    dispatch(getAbsenceRequests(undefined))
    dispatch(getAbsenceStatistics())
  }, [])

  if (
    typeof absenceRequests === 'undefined' ||
    typeof personStatistics === 'undefined'
  ) {
    return <Spinner />
  }
  if (user.isPartner) {
    return <p>This module wont work as a partner.</p>
  }
  return (
    <Switch>
      <Route exact path="/profile" component={Profile} />
      <Route path="/profile/settings" component={ProfileSettings} />
      <Route
        path="/profile/absence-request/add"
        component={AddAbsenceRequestNew}
      />
      <Route
        path="/profile/absence-request/edit/:absenceRequestUuid"
        component={EditAbsenceRequestNewPage}
      />
      <Route
        path="/profile/absence-request/:absenceRequestId/edit"
        component={UpdateAbsenceRequest}
      />
    </Switch>
  )
}
